module.exports = __webpack_public_path__ + "img/footer-contact-icon-row-dark-toyota.3f6e57c6.png";